import React, { useState } from 'react';

import { pageTitle as pageTitleService } from 'services/pageTitle';

import { useFullScreen } from 'hooks/useFullScreen';

import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { useSchedulerControls } from 'components/common/bryntumScheduler/SchedulerControlsHook';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import classes from 'components/pages/ScheduleViewsPage/ScheduleViewsPage.module.scss';
import { ViewsManager } from 'components/pages/ScheduleViewsPage/ViewsManager/ViewsManager';
import { useViewsManagerProvider } from 'components/pages/ScheduleViewsPage/ViewsManager/ViewsManager.provider';
import { EmptyState } from 'components/pages/ScheduleViewsPage/components/EmptyState/EmptyState';
import { SchedulerViewWrapper } from 'components/pages/ScheduleViewsPage/components/SchedulerViewWrapper/SchedulerViewWrapper';
import { ViewConfiguration } from 'components/pages/ScheduleViewsPage/components/ViewConfiguration/ViewConfiguration';
import { useScheduleViewIdUrlState } from 'components/pages/ScheduleViewsPage/hooks/useScheduleViewIdUrlState';
import { GanttChartCardModel } from 'components/widgets/Gantt/components/ganttChartCardModel';

export const ScheduleViewsPage = () => {
    pageTitleService.set(executionConfig.scheduleViews.title);
    const { api } = useViewsManagerProvider();
    const [isCreateViewModalOpen, setIsCreateViewModalOpen] = useState(false);
    const [isConfigureDrawerOpen, setIsConfigureDrawerOpen] = useState(false);
    const { data: visibleItems, isLoading } = api.getPrimaryViews.instance;
    const [viewId] = useScheduleViewIdUrlState();
    const { schedulerInstanceRef, controlsRef, update } = useSchedulerControls({});
    const { isFullscreen, onFullscreenChange, fullScreenWrapperRef } = useFullScreen();

    return (
        <PageContainer>
            <div
                ref={fullScreenWrapperRef}
                className={`${classes.presentationRegion}${
                    isFullscreen ? ` ${classes.presentationRegionFullscreen}` : ''
                }`}
            >
                <HeaderWrapper>
                    {!isFullscreen && (
                        <ViewsManager
                            isCreateViewModalOpen={isCreateViewModalOpen}
                            setIsCreateViewModalOpen={setIsCreateViewModalOpen}
                            api={api}
                        />
                    )}
                    {visibleItems && visibleItems.find((item) => item.viewId === Number(viewId)) && (
                        <ViewConfiguration
                            api={api}
                            isConfigureDrawerOpen={isConfigureDrawerOpen}
                            setIsConfigureDrawerOpen={setIsConfigureDrawerOpen}
                            update={update}
                            isPresentationMode={isFullscreen}
                            onTogglePresentationMode={onFullscreenChange}
                        />
                    )}
                </HeaderWrapper>
                <MainContent className={classes.scheduleMainContent}>
                    {isLoading ? (
                        <OverlayWithSpinner />
                    ) : !visibleItems || visibleItems.length === 0 ? (
                        <EmptyState onAddView={() => setIsCreateViewModalOpen(true)} />
                    ) : (
                        <SchedulerViewWrapper
                            api={api}
                            setIsConfigureDrawerOpen={setIsConfigureDrawerOpen}
                            schedulerInstanceRef={schedulerInstanceRef}
                            controlsRef={controlsRef}
                        />
                    )}
                </MainContent>
            </div>
            <GanttChartCardModel />
        </PageContainer>
    );
};
